import {assetsTypeMapping, generatePriceMapping} from '../common/couponConfig';
import Decimal from 'decimal';

function formatterCouponRes(res = {}) {
    const {accountAsset, getCoupons, hasRecharged} = res;
    const formatterRes = {getCoupons, hasRecharged};
    if (accountAsset && Array.isArray(accountAsset)) {
        accountAsset.forEach(({assetType, assetNum}) => {
            if (assetsTypeMapping[assetType]) {
                const v = assetsTypeMapping[assetType].value;
                if (!formatterRes[v]) {
                    formatterRes[v] = 0;
                }
                const oriNum = new Decimal(formatterRes[v]);
                const addNum = new Decimal(assetNum);
                formatterRes[v] = oriNum.add(addNum).toNumber();
            }
        });
    }
    const cashCoupon = formatterRes.cashCoupon || 0;
    const commonCoupon = formatterRes.commonCoupon || 0;
    const availablePoints = new Decimal(cashCoupon).add(new Decimal(commonCoupon)).toNumber();
    formatterRes.availablePoints = availablePoints;
    return formatterRes;
}
function formatterPriceRes(res = {}) {
    const formatterPriceRes = {};
    const {items} = res;
    if (Array.isArray(items)) {
        items.forEach(({skuType, sellPrice}) => {
            const values = generatePriceMapping[skuType];
            if (Array.isArray(values) && values.length) {
                values.forEach(v => {
                    formatterPriceRes[v] = sellPrice;
                });
            }
        });
    }
    return formatterPriceRes;
}
export default class CouponModel {
    constructor({request}) {
        this.request = request;
    }

    async getCouponInfo() {
        let res = await this.request.fetch('zebra/Post/CouponService/userCenter');
        return formatterCouponRes(res);
    }

    async getDetailList(params) {
        return this.request.fetch('zebra/Post/CouponService/consumptionHistory', params);
    }

    async getProductList(params) {
        return this.request.fetch('zebra/Post/QingDuoProductService/saleProductInfo', params);
    }

    async payOrder(params) {
        return this.request.fetch('zebra/Post/QingDuoProductService/purchaseProducts', params);
    }

    // 发放试用包
    async getTrialCoupon() {
        return this.request.fetch('zebra/Post/CouponService/sendCashCoupon');
    }

    // 获取各生成服务的价格表
    async getPriceList() {
        const params = {
            spuTypeEnum: 'AI_GENERATE_SERVICE'
        };
        let res = await this.request.fetch('zebra/Post/QingDuoProductService/saleProductInfo', params);
        return formatterPriceRes(res);
    }
}
